import React from 'react';
import { SvgProp } from './types';

export const EditIcon: React.FC<SvgProp> = ({ onClick, width, height, fill }) => {
  return (
    <svg
      width={width ?? '14'}
      height={height ?? '13'}
      viewBox="0 0 14 13"
      fill={fill ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M7.7143 0.607178C7.88726 0.60737 8.05361 0.673596 8.17938 0.792325C8.30514 0.911054 8.38082 1.07332 8.39096 1.24598C8.40109 1.41864 8.34492 1.58865 8.23391 1.72128C8.1229 1.85391 7.96544 1.93914 7.7937 1.95957L7.7143 1.96432H2.28573V11.4643H11.7857V6.03575C11.7859 5.8628 11.8521 5.69644 11.9709 5.57068C12.0896 5.44491 12.2519 5.36923 12.4245 5.3591C12.5972 5.34896 12.7672 5.40514 12.8998 5.51614C13.0325 5.62715 13.1177 5.78461 13.1381 5.95636L13.1429 6.03575V11.4643C13.143 11.8067 13.0137 12.1365 12.7809 12.3876C12.548 12.6386 12.2289 12.7924 11.8875 12.8181L11.7857 12.8215H2.28573C1.94334 12.8216 1.61356 12.6923 1.3625 12.4594C1.11144 12.2266 0.957661 11.9075 0.931982 11.5661L0.928589 11.4643V1.96432C0.928481 1.62193 1.05779 1.29215 1.2906 1.04109C1.52342 0.790033 1.84252 0.63625 2.18395 0.610571L2.28573 0.607178H7.7143ZM11.9506 0.839928C12.0727 0.718227 12.2366 0.647571 12.4089 0.642309C12.5812 0.637047 12.7491 0.697574 12.8784 0.811597C13.0077 0.925619 13.0888 1.08459 13.1051 1.25621C13.1215 1.42784 13.0719 1.59925 12.9664 1.73564L12.9101 1.80011L6.19227 8.51728C6.07015 8.63899 5.90629 8.70964 5.73397 8.7149C5.56165 8.72017 5.39378 8.65964 5.26447 8.54562C5.13516 8.43159 5.0541 8.27263 5.03775 8.101C5.0214 7.92937 5.07099 7.75796 5.17645 7.62157L5.23277 7.55779L11.9506 0.839928Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};
